import React from 'react';
import config from '../configuration';

export const CREATE_RATING = config.backendAddress + '/open/createRating';
export const SIGNUP = config.backendAddress + '/open/signup';
export const LOGIN = config.backendAddress + '/auth/login';
export const GET_AUTH_INFO = config.backendAddress + '/auth/getAuthInfo';
export const GET_OLD_USER = config.backendAddress + '/auth/getOldUser';
export const CREATE_TRACKING = config.backendAddress + '/open/createTracking';
export const CREATE_USER_PROFILE = config.backendAddress + '/users/createProfile';
